import {arrowUpRightSvg as Icon__small__arrowUpRightSvg} from '../Icon__small/Icon__small--arrowUpRight.js'
import {arrowUpRightSvg as Icon__xsmall__arrowUpRightSvg} from '../Icon__xsmall/Icon__xsmall--arrowUpRight.js'

export var arrowUpRight = {
  name: 'arrowUpRight',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowUpRightSvg,
  alt: {
    Icon__small: Icon__small__arrowUpRightSvg,
    Icon__xsmall: Icon__xsmall__arrowUpRightSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
